import { isObject, uniqBy } from 'lodash-es';
import { useMemo } from 'react';
import { useRoles } from './owner';

export type PathsInput<Paths extends PropertyKey[] = string[]> =
  // PropertyKey[] so callers can pass `RhinoAttributePaths<T>`; values are
  // attribute paths (strings) at runtime
  | Paths
  | ((roles: string[], resource?: unknown) => Paths)
  | Record<string, Paths>;

export const usePaths = (
  paths?: PathsInput<PropertyKey[]>,
  resource?: unknown
): string[] => {
  const roles = useRoles();

  return useMemo(() => {
    let computedPaths: string[] = [];
    if (Array.isArray(paths)) {
      computedPaths = paths as string[];
    } else if (typeof paths === 'function') {
      computedPaths = paths(roles, resource) as string[];
    } else if (isObject(paths)) {
      return uniqBy(
        roles.reduce<string[]>((previousValue, roleName) => {
          if (paths[roleName]) {
            return [...previousValue, ...(paths[roleName] as string[])];
          }
          return previousValue;
        }, []),
        (path) => path
      );
    }
    return computedPaths;
  }, [paths, roles, resource]);
};
